import { useEffect, useState } from 'react';

/**
 * Phone layout switch shared by Backoffice and B2C: width only (never the
 * device/OS), so a narrowed desktop window gets the phone UI too. Same
 * breakpoint as both apps: ≤ 767px.
 */
const PHONE_MEDIA_QUERY = '(max-width: 767px)';

const matches = () =>
  typeof window !== 'undefined' && !!window.matchMedia
    ? window.matchMedia(PHONE_MEDIA_QUERY).matches
    : false;

const useIsPhoneWidth = () => {
  const [isPhone, setIsPhone] = useState(matches);

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;
    const query = window.matchMedia(PHONE_MEDIA_QUERY);
    const onChange = () => setIsPhone(query.matches);
    onChange();
    query.addEventListener?.('change', onChange);
    return () => query.removeEventListener?.('change', onChange);
  }, []);

  return isPhone;
};

export default useIsPhoneWidth;
